import React from "react";
import { FaGithub, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { SiFreelancer } from "react-icons/si";
import { logo } from "../../assets/index";

const Footer = () => {
  return (
    <div className="w-full py-20 h-auto border-b border-white/10 flex justify-center items-center">
      <div className="w-full md:w-1/2 flex flex-col gap-8 items-center text-center">
        <img
          className="w-32 h-32 rounded-full object-cover"
          src={logo}
          alt="logo"
        />
        <div className="flex gap-4">
          <a
            href="https://github.com/chandramouli35"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/mouli-chandra/"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://x.com/Chandra37006776"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <FaTwitter />
          </a>
          <a
            href="https://www.freelancer.in/u/Chandramouli1m"
            target="_blank"
            rel="noopener noreferrer"
            className="bannerIcon"
          >
            <SiFreelancer />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
